import { createReducer, makeActionCreator } from "util/redux";

export const types = {
    ALERT_SHOW: "forms/ALERT_SHOW",
    ALERT_CLOSE: "forms/ALERT_CLOSE",
};

export const INITIAL_STATE = {
    displayAlert: false,
};

export default createReducer(INITIAL_STATE, {
    [types.ALERT_SHOW]: (state) => ({ ...state, displayAlert: true }),
    [types.ALERT_CLOSE]: (state) => ({ ...state, displayAlert: false }),
});

export const actions = {
    alertShow: makeActionCreator(types.ALERT_SHOW),
    alertClose: makeActionCreator(types.ALERT_CLOSE),
};

export const selectors = {
    getDisplayAlert: ({ alert }) => alert.displayAlert,
};
